import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import LanguageSwitcher from '../components/LanguageSwitcher';

export default function GetStartedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#F9F8F6' }} data-testid="get-started-page">
      {/* Back + Language */}
      <div className="flex items-center justify-between px-6 pt-6">
        <button onClick={() => navigate('/')} className="flex items-center gap-1 text-[#5C6656] hover:text-[#556B2F] transition-colors">
          <ArrowLeft size={20} />
        </button>
        <LanguageSwitcher variant="nav" />
      </div>

      {/* Center content */}
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-lg">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#1A2421] text-center mb-10" style={{ fontFamily: 'Outfit' }}>
            {t('login.loginTab')} / {t('login.registerTab')}
          </h1>

          <div className="space-y-4">
            {/* For customers */}
            <button
              onClick={() => navigate('/client-login')}
              data-testid="for-customers-btn"
              className="w-full flex items-center justify-between p-6 bg-white border border-[#E5E7E1] rounded-2xl hover:border-[#556B2F] hover:shadow-md transition-all group"
            >
              <div className="text-left">
                <h2 className="text-lg font-semibold text-[#1A2421]" style={{ fontFamily: 'Outfit' }}>Apptio for customers</h2>
                <p className="text-sm text-[#5C6656] mt-0.5">View and manage your bookings</p>
              </div>
              <ArrowRight size={20} className="text-[#5C6656] group-hover:text-[#556B2F] transition-colors" />
            </button>

            {/* For professionals */}
            <button
              onClick={() => navigate('/login')}
              data-testid="for-professionals-btn"
              className="w-full flex items-center justify-between p-6 bg-white border border-[#E5E7E1] rounded-2xl hover:border-[#556B2F] hover:shadow-md transition-all group"
            >
              <div className="text-left">
                <h2 className="text-lg font-semibold text-[#1A2421]" style={{ fontFamily: 'Outfit' }}>Apptio for professionals</h2>
                <p className="text-sm text-[#5C6656] mt-0.5">Manage and grow your business</p>
              </div>
              <ArrowRight size={20} className="text-[#5C6656] group-hover:text-[#556B2F] transition-colors" />
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center justify-center gap-6 py-6 text-sm text-[#5C6656]">
        <LanguageSwitcher variant="nav" />
      </div>
    </div>
  );
}
